import { getAppState } from "../state";

export function getAddOnByName(addOnName) {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === addOnName) || [];
  if (addOnsList?.length > 0) {
    return addOnsList[0];
  }
  return null;
}

export async function getSubscriptionDisplayName(addOnName) {
  const subscription = await getAddOnByName(addOnName);
  return (subscription && subscription?.displayName) || subscription?.name;
}
